<div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
<ng-container *ngIf="!isLoading">
  <pagination-controls
    *ngIf="activities?.length > 10"
    (pageChange)="p = $event"
    previousLabel="Previous"
    directionLinks="false"
    nextLabel="Next"
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="You're on page"
  ></pagination-controls>
  <ul class="organizer-activity-list" *ngIf="activities?.length > 0">
    <li
      *ngFor="
        let activity of activities
          | paginate: { itemsPerPage: 10, currentPage: p };
        index as itemIndex
      "
    >
      <a
        [routerLink]="['/organizer.activity.manage', activity.sku] | localize"
        [attr.aria-label]="activity.name"
      >
        <app-activity-card
          *ngIf="type !== activityTypeEnum.DRAFT"
          class="organizer-activity-list__activity-card"
          [id]="activity.sku"
          [reviewsStats]="getActivityReviewsStats(activity?.sku)"
          [picture]="getPicture(activity)"
          [title]="activity.name"
          [address]="activity.fullAddress"
          [price]="activity.startingPrice?.amount"
          [isStartingPrice]="true"
          [currency]="activity.startingPrice?.currency"
          [duration]="activity.formattedDuration(dateLocale)"
          [isLive]="activity.isLive"
          [visibility]="activity.visibility"
        ></app-activity-card>

        <app-activity-draft-card
          *ngIf="type === activityTypeEnum.DRAFT"
          class="organizer-activity-list__activity-card"
          [draftActivity]="activity"
        ></app-activity-draft-card>
      </a>
    </li>
  </ul>

  <pagination-controls
    *ngIf="activities?.length > 10"
    (pageChange)="changePage($event)"
    previousLabel="Previous"
    directionLinks="false"
    nextLabel="Next"
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="You're on page"
  ></pagination-controls>

  <ng-container *ngIf="activities?.length === 0">
    <app-tips
      class="block mt-4"
      [icon]="infoIconType"
      [variant]="tipsVariant.WARNING"
      [title]="'organizer.activities.no_results.title' | translate"
      [tips]="'organizer.activities.no_results.description' | translate"
    >
    </app-tips>

    <div class="spinner mx-auto mt-4" *ngIf="!activities"></div>
  </ng-container>
</ng-container>

<ng-container *ngIf="hasSubscriptionError">
  <app-tips
    class="block mt-4"
    [icon]="infoIconType"
    [variant]="tipsVariant.WARNING"
    [title]="'organizer.activities.error.title' | translate"
    [tips]="'organizer.activities.error.description' | translate"
  >
  </app-tips>
</ng-container>
